import 'core-js/es/array';
import 'babel-polyfill';

;(function($) {

	// get number of thead columns and add col-span property to body row, to stretch it
    if(document.querySelector('table.table-models thead th')) {
        var el = document.querySelector('table.table-models thead tr');
        var colsNum = el.cells.length;

        var elems = Array.from(document.querySelectorAll('table.table-models tbody td.card-wrapper'));

        elems.forEach(itm => {
            itm.colSpan = colsNum;
        });
    }

    if(document.querySelector('.tx-productdb .carousel')) {

        // IE11 object-fit fix
        let msie = window.navigator.userAgent.indexOf("MSIE");

        if (msie) {
            $(".carousel-item img.model-image").each(function() {
                if ($(this).width() > $(this).height()) $(this).addClass('wide-ie');
            })
        }

        // add class to opened row
        $("tr.head").click(function(e) {
            $(this).next().toggleClass('open');
        });

        // on mouse over, show/hide carousel controls
        $(".carousel").hover(
            function() {
                $(this).find(".carousel-control-prev, .carousel-control-next").css({
                    opacity: .5,
                    animation: 'none'
                });
            },
            function() {
                $(this).find(".carousel-control-prev, .carousel-control-next").css({
                    opacity: 0,
                    animation: 'none'
                });
            }
        );
    }

})(jQuery);
